
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sign/agent-trust",
      function () {
        return require("private-next-pages/sign/agent-trust.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sign/agent-trust"])
      });
    }
  